<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              @click="goBack"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="35">
            <h2>Vehicle Availability Detail</h2>
          </md-layout>
        </md-layout>
        <hr class="hr-s" />

        <div class="box">
          <div class="box-header"></div>
          <div>
            <h4 class="error">Note:- Please Select {{vCount}} Vehicle for this TPT assignment..!</h4>
          </div>

          <p v-if="vehicleArray.length>0">
            <span v-for="(item,index) in vehicleArray" :key="index">
              <md-chip md-deletable @delete="delete1(index)">{{item}}</md-chip>
            </span>
          </p>
          <br />
          <hr class="hr-border" />

          <div class="box-body" v-if="showMailDetails.length>0">
            <table id="truckDetail2222" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Vehicle No.</th>
                  <th>Location</th>
                  <th>Add</th>
                  <!-- <th>Date & Time1</th>
                  <th>Updated By</th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in showMailDetails " :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.regdNo}}</td>
                  <td>{{item.location_description}}</td>
                  <td>
                    <md-button
                      :disabled="parseInt(vCount)==vehicleArray.length?true:false"
                      class="md-icon-button md-raised md-dense"
                      @click="addVehicle(item.regdNo)"
                    >
                      <md-icon>add</md-icon>
                    </md-button>
                  </td>

                  <!-- <td>{{item.loginTime | moment}}</td>
                  <td>{{item.fromGps=='1'?'GPS':'SYS1TEM'}}</td>-->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/vehicleBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      alert: {
        content:
          this.$sessionsStorage.get("editDriverId") != "" &&
          this.$sessionsStorage.get("editDriverId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      arrayerrorSend: ["Select Activity ", "Select Vehicle "],
      errorSend: {
        event: "",
        vehicleTruckId: ""
      },
      vCount: this.$sessionsStorage.get("VehicleCount"),
      AllDetails: {},
      addM: false,
      showMailDetails: [],
      vehicleList: [],
      isLoading: false,
      emailBody: [],
      validateTrans: true,
      emailModal: {
        transportMailId: "",
        vehicleTruckId: "",
        event: "",
        emailContent: "",
        clientEmail: "",
        mailCC: "",
        assignId: this.$sessionsStorage.get("storeAssignId"),
        clientName: "",
        clientId: ""
      },
      vehicleArray: []
    };
  },
  filters: {
    moment(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  },
  mounted() {},
  beforeDestroy() {
    if (this.vehicleArray.length > 0) {
      let payload = {
        assignId: this.$sessionsStorage.get("storeAssignId"),
        vehicleArray: this.vehicleArray
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/assignmentDummyVehicle.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
          }
        })
        .catch(error => {});
    }
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {},
  watch: {
    emailModal: {
      handler: function(newVal, oldVal) {
        if (
          this.emailModal.event != "" &&
          this.emailModal.transportMailId == ""
        ) {
          let arry3 = this.emailBody.filter(x => {
            return x.contentId == this.emailModal.event;
          });

          var str = arry3[0].description.replace(
            "ASSIGNMENT_SERIES",
            this.AllDetails.assignSeries
          );
          str = str.replace(
            "FACTORY_LOCATION",
            this.AllDetails.StuffingLocation
          );
          str = str.replace("PICKUPLOCATION", this.AllDetails.fromLocation);
          str = str.replace("FINAL_PLACE", this.AllDetails.toLocation);
          str = str.replace("CLIENT_NAME", this.AllDetails.clientName);
          str = str.replace("TRUCK_NO", this.AllDetails.regdNo);
          this.emailModal.emailContent = str;
        }

        if (this.emailModal.transportMailId == "") {
          let arry = this.showMailDetails.filter(x => {
            return x.event == this.emailModal.event;
          });

          if (arry.length > 0) {
            this.alert.content = "Event Already Executed";
            this.$refs["addPop"].open();
            this.emailModal.event = "";
            this.emailModal.emailContent = "";
          }
        }
      },
      deep: true
    }
  },
  methods: {
    delete1(index) {
      this.vehicleArray.splice(index, 1);
    },
    addVehicle(item) {
      let index = this.vehicleArray.indexOf(item);
      if (index >= 0) {
        alert("already Exist");
      } else {
        this.vehicleArray.push(item);
      }
    },
    addManual() {
      this.addM = true;
    },
    clearAll() {
      Object.keys(this.emailModal).map(x => {
        this.emailModal[x] = "";
      });
    },
    editMail(item) {
      this.addM = true;
      Object.keys(this.emailModal).map(x => {
        this.emailModal[x] = item[x] || "";
      });

      window.scroll(0, 25);
    },
    goBack() {
      if (this.$sessionsStorage.get("backToDetailPage") == "22") {
        this.$router.push({
          path: "/listView/viewSalesBooking"
        });
      } else {
        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      }
    },
    validateSend() {
      let validate_new = true;

      Object.keys(this.errorSend).map((x, index) => {
        if (this.emailModal[x] == "") {
          this.errorSend[x] = this.arrayerrorSend[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    sendMail() {
      let mail = {
        emailModal: this.emailModal,
        AllDetails: this.AllDetails
      };

      this.validateSend();
      if (this.validateTrans != false) {
        $("#sendLoaderMain").css("display", "none");
        $("#sendLoader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Transport/addTransportationMails.php`,
          data: JSON.stringify(mail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#sendLoader").css("display", "none");
              $("#sendLoaderMain").css("display", "block");
              this.alert.content = "Mail Sent";

              this.$refs["addPop"].open();
              this.getData();
              this.addM = false;
            }
          })
          .catch(error => {});
      }
    },
    getData() {
      let vehicle_drive = {
        mail: "mail",
        assignId: this.$sessionsStorage.get("storeAssignId"),
        storeLength: this.$store.getters.storeVehileDataList.length
      };
      console.log(vehicle_drive);
      this.isLoading = true;

      let options = {
        method: "POST",
        url: `${URL_BASE}/vehcilegpsDetail.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.dummyVehicle != "" && data.dummyVehicle != null) {
              this.vehicleArray = data.dummyVehicle;
            }

            if (data.updateMailData.length > 0) {
              this.showMailDetails = data.updateMailData;
              this.$store.dispatch("setVehicleList", data.updateMailData);
            } else {
              this.showMailDetails = [];
            }

            if (this.$store.getters.storeVehileDataList.length > 0) {
              this.showMailDetails = this.$store.getters.storeVehileDataList;
            }

            this.isLoading = false;
            // this.doLoading();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    JqueryFun() {
      return $(function() {
        $("#truckDetail2222").DataTable();
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 22% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}

.margTop-Booking {
  margin-top: 2%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
  background-color: #607d8d !important;
  height: 10px;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container {
  z-index: 999999 !important;
}
</style>


// WEBPACK FOOTER //
// vehicleDetailLocation.vue?445aef1e